import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "title_container" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 3,
  ref: "form"
}
const _hoisted_6 = { class: "grid" }
const _hoisted_7 = { class: "grid" }
const _hoisted_8 = { class: "grid" }
const _hoisted_9 = { class: "grid" }
const _hoisted_10 = { class: "grid" }
const _hoisted_11 = { class: "grid" }
const _hoisted_12 = { class: "grid" }
const _hoisted_13 = { class: "grid" }
const _hoisted_14 = { class: "grid" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { style: {"margin-top":"2rem"} }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "step_buttons_container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step = _resolveComponent("Step")!
  const _component_StepList = _resolveComponent("StepList")!
  const _component_Select = _resolveComponent("Select")!
  const _component_FormField = _resolveComponent("FormField")!
  const _component_ListBox = _resolveComponent("ListBox")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TelInput = _resolveComponent("TelInput")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_StepPanel = _resolveComponent("StepPanel")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PaymentProcessor = _resolveComponent("PaymentProcessor")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_StepPanels = _resolveComponent("StepPanels")!
  const _component_Stepper = _resolveComponent("Stepper")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "page" }, {
    content: _withCtx(() => [
      (_ctx.logoDark && _ctx.themeStore.getTheme === 'dark')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "logo",
            src: _ctx.logoDark,
            alt: "logo"
          }, null, 8, _hoisted_1))
        : (_ctx.logoLight && _ctx.themeStore.getTheme === 'light')
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "logo",
              src: _ctx.logoLight,
              alt: "logo"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t("student_views.public_register_view.view.title")), 1)
      ]),
      (!_ctx.canRegister)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("student_views.public_register_view.view.student_can_not_register")), 1)
          ]))
        : (_openBlock(), _createElementBlock("form", _hoisted_5, [
            _createVNode(_component_Stepper, {
              value: _ctx.activeStep,
              "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.activeStep) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_StepList, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Step, {
                      value: 1,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("student_views.public_register_view.view.step1.title")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Step, {
                      value: 2,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("student_views.public_register_view.view.step2.title")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Step, {
                      value: 3,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("student_views.public_register_view.view.step3.title")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_StepPanels, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_StepPanel, { value: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FormField, {
                          label: _ctx.$t('student_views.public_register_view.view.step1.register_type'),
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Select, {
                              options: _ctx.registerTypeOptions,
                              optionLabel: _ctx.getRegisterTypeLabel,
                              modelValue: _ctx.registerType,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registerType) = $event)),
                              invalid: (_ctx.tryToGo > 1 && _ctx.isNull(_ctx.registerType))
                            }, null, 8, ["options", "optionLabel", "modelValue", "invalid"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        (_ctx.registerType == 'course' || _ctx.registerType == 'both')
                          ? (_openBlock(), _createBlock(_component_FormField, {
                              key: 0,
                              label: _ctx.$t('student_views.public_register_view.view.step1.courses'),
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ListBox, {
                                  filter: "",
                                  modelValue: _ctx.student.courseRegistrations,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.student.courseRegistrations) = $event)),
                                  options: _ctx.courses,
                                  multiple: "",
                                  filterFields: ['name','day','startHour'],
                                  invalid: (_ctx.tryToGo > 1 && (_ctx.student.courseRegistrations === undefined || _ctx.student.courseRegistrations.length === 0)),
                                  filterPlaceholder: _ctx.$t('student_views.public_register_view.view.step1.search_input'),
                                  ref: "courseList"
                                }, {
                                  option: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.option.name) + " - " + _toDisplayString(slotProps.option.day) + " - " + _toDisplayString(slotProps.option.startHour) + " / " + _toDisplayString(slotProps.option.minimumAge) + " " + _toDisplayString(_ctx.$t("global.age_suffix")) + " - " + _toDisplayString(slotProps.option.maximumAge) + " " + _toDisplayString(_ctx.$t("global.age_suffix")), 1)
                                  ]),
                                  header: _withCtx(() => [
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.selectFilters,
                                      "onUpdate:modelValue": [
                                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectFilters) = $event)),
                                        _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.courseList.filterValue=_ctx.selectFilters))
                                      ],
                                      options: _ctx.courseSelectFilter,
                                      fluid: "",
                                      placeholder: _ctx.$t('student_views.public_register_view.view.step1.filter')
                                    }, null, 8, ["modelValue", "options", "placeholder"])
                                  ]),
                                  emptyfilter: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('student_views.public_register_view.view.step1.no_result')), 1)
                                  ]),
                                  empty: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('student_views.public_register_view.view.step1.no_result')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "options", "invalid", "filterPlaceholder"])
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (_ctx.registerType == 'workshop' || _ctx.registerType == 'both')
                          ? (_openBlock(), _createBlock(_component_FormField, {
                              key: 1,
                              label: _ctx.$t('student_views.public_register_view.view.step1.workshops'),
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ListBox, {
                                  filter: "",
                                  modelValue: _ctx.student.workshopRegistrations,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.student.workshopRegistrations) = $event)),
                                  options: _ctx.workshops,
                                  multiple: "",
                                  filterFields: ['name','startDate', 'endDate'],
                                  invalid: (_ctx.tryToGo > 1 && (_ctx.student.workshopRegistrations === undefined || _ctx.student.workshopRegistrations.length === 0)),
                                  filterPlaceholder: _ctx.$t('student_views.public_register_view.view.step1.search_input')
                                }, {
                                  option: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.option.name) + " / " + _toDisplayString(slotProps.option.startDate) + " - " + _toDisplayString(slotProps.option.endDate) + " / " + _toDisplayString(slotProps.option.minimumAge) + " " + _toDisplayString(_ctx.$t("global.age_suffix")) + " - " + _toDisplayString(slotProps.option.maximumAge) + " " + _toDisplayString(_ctx.$t("global.age_suffix")) + " / " + _toDisplayString(_ctx.priceFormat(slotProps.option.price)), 1)
                                  ]),
                                  emptyfilter: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('student_views.public_register_view.view.step1.no_result')), 1)
                                  ]),
                                  empty: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('student_views.public_register_view.view.step1.no_result')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "options", "invalid", "filterPlaceholder"])
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : _createCommentVNode("", true),
                        _cache[33] || (_cache[33] = _createElementVNode("h2", null, "Élève", -1)),
                        _createElementVNode("fieldset", _hoisted_6, [
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.firstname'),
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.student.firstname,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.student.firstname) = $event)),
                                required: "",
                                invalid: (_ctx.tryToGo > 1 && _ctx.isNull(_ctx.student?.firstname))
                              }, null, 8, ["modelValue", "invalid"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.name'),
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.student.name,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.student.name) = $event)),
                                required: "",
                                invalid: (_ctx.tryToGo > 1 && _ctx.isNull(_ctx.student?.name))
                              }, null, 8, ["modelValue", "invalid"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _createElementVNode("fieldset", _hoisted_7, [
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.gender'),
                            required: "",
                            is50Width: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Select, {
                                modelValue: _ctx.student.gender,
                                "onUpdate:modelValue": [
                                  _cache[7] || (_cache[7] = ($event: any) => ((_ctx.student.gender) = $event)),
                                  _cache[8] || (_cache[8] = ($event: any) => (_ctx.hasEdit = true))
                                ],
                                options: _ctx.genderOptions,
                                optionLabel: _ctx.getGenderLabel,
                                invalid: (_ctx.tryToGo > 1 && _ctx.isNull(_ctx.student.gender)),
                                showClear: !_ctx.isNull(_ctx.student.gender)
                              }, null, 8, ["modelValue", "options", "optionLabel", "invalid", "showClear"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.birthday'),
                            required: "",
                            is50Width: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DatePicker, {
                                dateFormat: "dd/mm/yy",
                                modelValue: _ctx.student.birthday,
                                "onUpdate:modelValue": [
                                  _cache[9] || (_cache[9] = ($event: any) => ((_ctx.student.birthday) = $event)),
                                  _cache[10] || (_cache[10] = ($event: any) => (_ctx.hasEdit = true))
                                ],
                                showIcon: "",
                                iconDisplay: "input",
                                maxDate: new Date(),
                                invalid: (_ctx.tryToGo > 1 && _ctx.isNull(_ctx.student?.birthday))
                              }, null, 8, ["modelValue", "maxDate", "invalid"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _createElementVNode("fieldset", _hoisted_8, [
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.email'),
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.student.email,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.student.email) = $event)),
                                type: "email",
                                required: "",
                                invalid: (_ctx.tryToGo > 1 && _ctx.isNull(_ctx.student?.email))
                              }, null, 8, ["modelValue", "invalid"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.email2')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.student.email2,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.student.email2) = $event)),
                                type: "email"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _createElementVNode("fieldset", _hoisted_9, [
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.phone')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TelInput, {
                                modelValue: _ctx.student.phone,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.student.phone) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.landline_phone')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TelInput, {
                                modelValue: _ctx.student.landLinePhone,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.student.landLinePhone) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _createVNode(_component_FormField, {
                          label: _ctx.$t('student_views.public_register_view.view.step1.medical_history')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Textarea, {
                              modelValue: _ctx.student.medicalHistory,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.student.medicalHistory) = $event)),
                              autoResize: "",
                              fluid: true
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _cache[34] || (_cache[34] = _createElementVNode("h2", null, "Adresse", -1)),
                        _createVNode(_component_FormField, {
                          label: _ctx.$t('student_views.public_register_view.view.step1.address1'),
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.student.address.address1,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.student.address.address1) = $event)),
                              required: "",
                              invalid: (_ctx.tryToGo > 1 && _ctx.isNull(_ctx.student?.address?.address1))
                            }, null, 8, ["modelValue", "invalid"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_FormField, {
                          label: _ctx.$t('student_views.public_register_view.view.step1.address2')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.student.address.address2,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.student.address.address2) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createElementVNode("fieldset", _hoisted_10, [
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.postal_code'),
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.student.address.postalCode,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.student.address.postalCode) = $event)),
                                required: "",
                                invalid: (_ctx.tryToGo > 1 && _ctx.isNull(_ctx.student?.address?.postalCode))
                              }, null, 8, ["modelValue", "invalid"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.city'),
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.student.address.city,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.student.address.city) = $event)),
                                required: "",
                                invalid: (_ctx.tryToGo > 1 && _ctx.isNull(_ctx.student?.address?.city))
                              }, null, 8, ["modelValue", "invalid"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _createVNode(_component_FormField, {
                          label: _ctx.$t('student_views.public_register_view.view.step1.country'),
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Select, {
                              modelValue: _ctx.student.address.country,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.student.address.country) = $event)),
                              options: _ctx.countryOptions,
                              optionLabel: _ctx.getCountryLabel,
                              invalid: (_ctx.tryToGo > 1 && _ctx.isNull(_ctx.student?.address?.country)),
                              showClear: !_ctx.isNull(_ctx.student?.address?.country)
                            }, null, 8, ["modelValue", "options", "optionLabel", "invalid", "showClear"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("student_views.public_register_view.view.step1.contact_people_text")), 1),
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("student_views.public_register_view.view.step1.contact1")), 1),
                        _createElementVNode("fieldset", _hoisted_11, [
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.firstname'),
                            required: _ctx.isContactPeopleRequired
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.contactPerson1.firstname,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.contactPerson1.firstname) = $event)),
                                required: _ctx.isContactPeopleRequired,
                                invalid: (_ctx.tryToGo > 1 && _ctx.isContactPeopleRequired && _ctx.isNull(_ctx.contactPerson1.firstname))
                              }, null, 8, ["modelValue", "required", "invalid"])
                            ]),
                            _: 1
                          }, 8, ["label", "required"]),
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.name'),
                            required: _ctx.isContactPeopleRequired
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.contactPerson1.name,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.contactPerson1.name) = $event)),
                                required: _ctx.isContactPeopleRequired,
                                invalid: (_ctx.tryToGo > 1 && _ctx.isContactPeopleRequired && _ctx.isNull(_ctx.contactPerson1.name))
                              }, null, 8, ["modelValue", "required", "invalid"])
                            ]),
                            _: 1
                          }, 8, ["label", "required"])
                        ]),
                        _createElementVNode("fieldset", _hoisted_12, [
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.email'),
                            is50Width: "",
                            required: _ctx.isContactPeopleRequired
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                required: _ctx.isContactPeopleRequired,
                                modelValue: _ctx.contactPerson1.email,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.contactPerson1.email) = $event)),
                                type: "email",
                                invalid: (_ctx.tryToGo > 1 && _ctx.isContactPeopleRequired && _ctx.isNull(_ctx.contactPerson1.email))
                              }, null, 8, ["required", "modelValue", "invalid"])
                            ]),
                            _: 1
                          }, 8, ["label", "required"]),
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.phone'),
                            is50Width: "",
                            required: _ctx.isContactPeopleRequired
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TelInput, {
                                required: _ctx.isContactPeopleRequired,
                                modelValue: _ctx.contactPerson1.phone,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.contactPerson1.phone) = $event)),
                                invalid: (_ctx.tryToGo > 1 && _ctx.isContactPeopleRequired && _ctx.isNull(_ctx.contactPerson1.phone))
                              }, null, 8, ["required", "modelValue", "invalid"])
                            ]),
                            _: 1
                          }, 8, ["label", "required"])
                        ]),
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("student_views.public_register_view.view.step1.contact2")), 1),
                        _createElementVNode("fieldset", _hoisted_13, [
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.firstname')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.contactPerson2.firstname,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.contactPerson2.firstname) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.name')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.contactPerson2.name,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.contactPerson2.name) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _createElementVNode("fieldset", _hoisted_14, [
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.email'),
                            is50Width: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.contactPerson2.email,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.contactPerson2.email) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_FormField, {
                            label: _ctx.$t('student_views.public_register_view.view.step1.phone'),
                            is50Width: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TelInput, {
                                modelValue: _ctx.contactPerson2.phone,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.contactPerson2.phone) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_StepPanel, { value: 2 }, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("student_views.public_register_view.view.step2.payment_title")), 1),
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("student_views.public_register_view.view.step2.summary_title")), 1),
                        (this.isStudentExisting)
                          ? (_openBlock(), _createBlock(_component_Message, {
                              key: 0,
                              severity: "warn"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("student_views.public_register_view.view.step2.is_existing_student")), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_DataTable, { value: _ctx.paymentTable }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Column, {
                              field: "name",
                              header: _ctx.$t('student_views.public_register_view.view.step2.name')
                            }, {
                              body: _withCtx((slotProps) => [
                                (slotProps.data.bold)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_15, _toDisplayString(slotProps.data.name), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(slotProps.data.name), 1))
                              ]),
                              _: 1
                            }, 8, ["header"]),
                            _createVNode(_component_Column, {
                              field: "price",
                              header: _ctx.$t('student_views.public_register_view.view.step2.price')
                            }, {
                              body: _withCtx((slotProps) => [
                                (slotProps.data.bold)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_17, _toDisplayString(typeof slotProps.data.price == "number" ? _ctx.priceFormat(slotProps.data.price): slotProps.data.price), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(typeof slotProps.data.price == "number" ? _ctx.priceFormat(slotProps.data.price): slotProps.data.price), 1))
                              ]),
                              _: 1
                            }, 8, ["header"])
                          ]),
                          _: 1
                        }, 8, ["value"]),
                        _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.$t('student_views.public_register_view.view.step2.payment_method')), 1),
                        _createVNode(_component_PaymentProcessor, {
                          ref: "paymentProcessor",
                          paymentType: _ctx.typeRegistration,
                          paymentItems: _ctx.paymentItems,
                          onPaymentCompleted: _ctx.postFormApi,
                          onPaymentStatusChange: _ctx.paymentStatusChange,
                          onPaymentCreated: _ctx.paymentCreated
                        }, {
                          bankTransferText: _withCtx(() => [
                            _createElementVNode("p", {
                              innerHTML: _ctx.$t('student_views.public_register_view.view.step2.payment_bank_transfert_infos',{price: _ctx.priceFormat(_ctx.totalPrice)})
                            }, null, 8, _hoisted_20)
                          ]),
                          _: 1
                        }, 8, ["paymentType", "paymentItems", "onPaymentCompleted", "onPaymentStatusChange", "onPaymentCreated"]),
                        _createVNode(_component_FormField, {
                          label: _ctx.$t('student_views.public_register_view.view.step2.rules_consent'),
                          isCheckBox: "",
                          style: {"margin-top":"3rem"},
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Checkbox, {
                              modelValue: _ctx.rulesConsent,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.rulesConsent) = $event)),
                              binary: "",
                              required: _ctx.activeStep == 2,
                              invalid: (_ctx.tryToGo > 2 && !_ctx.rulesConsent)
                            }, null, 8, ["modelValue", "required", "invalid"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_FormField, {
                          label: _ctx.$t('student_views.public_register_view.view.step2.gdpr_consent'),
                          isCheckBox: "",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Checkbox, {
                              modelValue: _ctx.gdprConsent,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.gdprConsent) = $event)),
                              binary: "",
                              required: _ctx.activeStep == 2,
                              invalid: (_ctx.tryToGo > 2 && !_ctx.gdprConsent)
                            }, null, 8, ["modelValue", "required", "invalid"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_FormField, {
                          label: _ctx.$t('student_views.public_register_view.view.step2.image_right'),
                          isCheckBox: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Checkbox, {
                              modelValue: _ctx.student.imageRight,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.student.imageRight) = $event)),
                              binary: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_StepPanel, { value: 3 }, {
                      default: _withCtx(() => [
                        (_ctx.allSuccess)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.$t("student_views.public_register_view.view.step3.saved_success")), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.$t("student_views.public_register_view.view.step3.error")), 1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_Button, {
                style: _normalizeStyle(this.activeStep == 2 ? '': 'visibility: hidden'),
                label: _ctx.$t('student_views.public_register_view.view.previous_button'),
                severity: "secondary",
                icon: "pi pi-arrow-left",
                onClick: _ctx.prev
              }, null, 8, ["style", "label", "onClick"]),
              _createVNode(_component_Button, {
                style: _normalizeStyle(this.activeStep == 3 ? 'visibility: hidden': ''),
                label: _ctx.$t('student_views.public_register_view.view.next_button'),
                iconPos: "right",
                severity: "secondary",
                icon: "pi pi-arrow-right",
                onClick: _ctx.next
              }, null, 8, ["style", "label", "onClick"])
            ])
          ], 512))
    ]),
    _: 1
  }))
}